// ---------------------------------------------------//
// ----------------Directions and prices--------------//
// ---------------------------------------------------//


let namesLocations = {}; // названия всех направлений в нашей системе (ключ+значение)

function getNamesLocationsByLanguage(language){
  if(language=="en"){
      namesLocations = {
        palermoairport: "Palermo airport",
        palermocity: "Palermo city",
        palermoport: "Palermo port",
        mondello: "Mondello",
        monreale: "Monreale",
        cinisi: "Cinisi",
        terrasini: "Terrasini",
        castellamaredelgolfo: "Castellamare del Golfo",
        sanvitolocapo: "San Vito Lo Capo",
        erice: "Erice",
        riservadellozingaro: "Riserva dello Zingaro",
        trapani: "Trapani",
        trapanibirgiairport: "Trapani Birgi Airport",
        mozia: "Mozia",
        castelvetrano: "Castelvetrano",
        selinunte: "Selinunte",
        segesta: "Segesta",
        salineditrapani: "Saline di Trapani",
        marsala: "Marsala",
        sambucadisicilia: "Sambuca di Sicilia",
        mazaradelvallo: "Mazara del Vallo",
        bagheria: "Bagheria",
        santaflavia: "Santa Flavia",
        cefalu: "Cefalù",
        corleone: "Corleone",
        agrigento: "Agrigento",
        menfi: "Menfi",
        valledeitempli: "Valle dei Templi",
        sciacca: "Sciacca",
        portopalo: "Porto Palo",
        scaladeiturchi: "Scala dei Turchi",
        enna: "Enna",
        caltanissetta: "Caltanissetta",
        siciliavillageoutlet: "Sicilia Village Outlet",
        piazzaarmerina: "Piazza Armerina",
        cataniaairport: "Catania Airport",
        cataniacity: "Catania city",
        etnaland: "Etnaland",
        etna: "Etna",
        taormina: "Taormina",
        giardininaxos: "Giardini Naxos",
        siracusa: "Siracusa",
        marinadiragusa: "Marina di Ragusa",
        noto: "Noto",
        letojanni: "Letojanni",
        comisoairport: "Comiso Airport",
        messinaport: "Messina port",
        milazzo: "Milazzo",
        milazzoport: "Milazzo port",
        acireale: "Acireale",
        modica: "Modica",
        augusta: "Augusta",
        sigonella: "Sigonella",
        marzamemi: "Marzamemi",
        goledellalcantara: "Gole dell'Alcantara",
        caltagirone: "Caltagirone",
        trapaniport: "Trapani port",
        dattilo: "Dattilo",
        altavillamilicia: "Altavilla Milicia",
        trabia: "Trabia",
        giardinellozucco: "Giardinello Zucco",
        addaura: "Addaura",
        scopello: "Scopello",
        bolognetta: "Bolognetta",
        campofelicediroccella: "Campofelice di Roccella",
        parcodellemadonie: "Parco delle Madonie",
        pianadeglialbanesi: "Piana degli Albanesi",
        altofonte: "Altofonte",
        partinico: "Partinico",
        balestrate: "Balestrate",
        terminiimerese: "Termini Imerese",
        villabate: "Villabate",
        alcamo: "Alcamo",
        casteldaccia: "Casteldaccia",
        aspra: "Aspra",
        misilmeri: "Misilmeri",
        montelepre: "Montelepre",
        macari: "Macari",
        termesegestane: "Terme Segestane",
        sangiuseppejato: "San Giuseppe Jato",
        borgetto: "Borgetto",
        giacalone: "Giacalone",
        ciminna: "Ciminna",
        paceco: "Paceco",
        vicari: "Vicari",
        lercarafriddi: "Lercara Friddi",
        sannicolalarena: "San Nicola l'Arena",
        isoladellefemmine: "Isola delle Femmine",
        capaci: "Capaci",
        carini: "Carini",
        custonaci: "Custonaci",
        gioiosamarea: "Gioiosa Marea",
        licata: "Licata",
        pollina: "Pollina",
        portoempedocle: "Porto Empedocle",
        prizzi: "Prizzi",
        sferracavallo: "Sferracavallo",
        trappeto: "Trappeto",
        valderice: "Valderice",
        acitrezza: "Aci Trezza",
        calatabiano: "Calatabiano",
        giarre: "Giarre",
        messina: "Messina",
        ragusa: "Ragusa",
        portorosa: "Portorosa",
        ortigia: "Ortigia"
      }; 
  }else if(language=="it"){
    namesLocations = {
      palermoairport: "Palermo aeroporto",
      palermocity: "Palermo città",
      palermoport: "Palermo porto",
      mondello: "Mondello",
      monreale: "Monreale",
      cinisi: "Cinisi",
      terrasini: "Terrasini",
      castellamaredelgolfo: "Castellamare del Golfo",
      sanvitolocapo: "San Vito Lo Capo",
      erice: "Erice",
      riservadellozingaro: "Riserva dello Zingaro",
      trapani: "Trapani",
      trapanibirgiairport: "Trapani Birgi Aeroporto",
      mozia: "Mozia",
      castelvetrano: "Castelvetrano",
      selinunte: "Selinunte",
      segesta: "Segesta",
      salineditrapani: "Saline di Trapani",
      marsala: "Marsala",
      sambucadisicilia: "Sambuca di Sicilia",
      mazaradelvallo: "Mazara del Vallo",
      bagheria: "Bagheria",
      santaflavia: "Santa Flavia",
      cefalu: "Cefalù",
      corleone: "Corleone",
      agrigento: "Agrigento",
      menfi: "Menfi",
      valledeitempli: "Valle dei Templi",
      sciacca: "Sciacca",
      portopalo: "Porto Palo",
      scaladeiturchi: "Scala dei Turchi",
      enna: "Enna",
      caltanissetta: "Caltanissetta",
      siciliavillageoutlet: "Sicilia Village Outlet",
      piazzaarmerina: "Piazza Armerina",
      cataniaairport: "Catania Aeroporto",
      cataniacity: "Catania città",
      etnaland: "Etnaland",
      etna: "Etna",
      taormina: "Taormina",
      giardininaxos: "Giardini Naxos",
      siracusa: "Siracusa",
      marinadiragusa: "Marina di Ragusa",
      noto: "Noto",
      letojanni: "letojanni",
      comisoairport: "Comiso Aeroporto",
      messinaport: "Messina porto",
      milazzo: "Milazzo",
      milazzoport: "Milazzo porto",
      acireale: "Acireale",
      modica: "Modica",
      augusta: "Augusta",
      sigonella: "Sigonella",
      marzamemi: "Marzamemi",
      goledellalcantara: "Gole dell'Alcantara",
      caltagirone: "Caltagirone",
      trapaniport: "Trapani porto",
      dattilo: "Dattilo",
      altavillamilicia: "Altavilla Milicia",
      trabia: "Trabia",
      giardinellozucco: "Giardinello Zucco",
      addaura: "Addaura",
      scopello: "Scopello",
      bolognetta: "Bolognetta",
      campofelicediroccella: "Campofelice di Roccella",
      parcodellemadonie: "Parco delle Madonie",
      pianadeglialbanesi: "Piana degli Albanesi",
      altofonte: "Altofonte",
      partinico: "Partinico",
      balestrate: "Balestrate",
      terminiimerese: "Termini Imerese",
      villabate: "Villabate",
      alcamo: "Alcamo",
      casteldaccia: "Casteldaccia",
      aspra: "Aspra",
      misilmeri: "Misilmeri",
      montelepre: "Montelepre",
      macari: "Macari",
      termesegestane: "Terme Segestane",
      sangiuseppejato: "San Giuseppe Jato",
      borgetto: "Borgetto",
      giacalone: "Giacalone",
      ciminna: "Ciminna",
      paceco: "Paceco",
      vicari: "Vicari",
      lercarafriddi: "Lercara Friddi",
      sannicolalarena: "San Nicola l'Arena",
      isoladellefemmine: "Isola delle Femmine",
      capaci: "Capaci",
      carini: "Carini",
      custonaci: "Custonaci",
      gioiosamarea: "Gioiosa Marea",
      licata: "Licata",
      pollina: "Pollina",
      portoempedocle: "Porto Empedocle",
      prizzi: "Prizzi",
      sferracavallo: "Sferracavallo",
      trappeto: "Trappeto",
      valderice: "Valderice",
      acitrezza: "Aci Trezza",
      calatabiano: "Calatabiano",
      giarre: "Giarre",
      messina: "Messina",
      ragusa: "Ragusa",
      portorosa: "Portorosa",
      ortigia: "Ortigia"
    }; 
  }else{
    namesLocations = {
      palermoairport: "Palermo Aeropuerto",
      palermocity: "Palermo Ciudad",
      palermoport: "Palermo puerto",
      mondello: "Mondello",
      monreale: "Monreale",
      cinisi: "Cinisi",
      terrasini: "Terrasini",
      castellamaredelgolfo: "Castellamare del Golfo",
      sanvitolocapo: "San Vito Lo Capo",
      erice: "Erice",
      riservadellozingaro: "Riserva dello Zingaro",
      trapani: "Trapani",
      trapanibirgiairport: "Trapani Birgi Aeropuerto",
      mozia: "Mozia",
      castelvetrano: "Castelvetrano",
      selinunte: "Selinunte",
      segesta: "Segesta",
      salineditrapani: "Saline di Trapani",
      marsala: "Marsala",
      sambucadisicilia: "Sambuca di Sicilia",
      mazaradelvallo: "Mazara del Vallo",
      bagheria: "Bagheria",
      santaflavia: "Santa Flavia",
      cefalu: "Cefalù",
      corleone: "Corleone",
      agrigento: "Agrigento",
      menfi: "Menfi",
      valledeitempli: "Valle dei Templi",
      sciacca: "Sciacca",
      portopalo: "Porto Palo",
      scaladeiturchi: "Scala dei Turchi",
      enna: "Enna",
      caltanissetta: "Caltanissetta",
      siciliavillageoutlet: "Sicilia Village Outlet",
      piazzaarmerina: "Piazza Armerina",
      cataniaairport: "Catania Aeropuerto",
      cataniacity: "Catania Ciudad",
      etnaland: "Etnaland",
      etna: "Etna",
      taormina: "Taormina",
      giardininaxos: "Giardini Naxos",
      siracusa: "Siracusa",
      marinadiragusa: "Marina di Ragusa",
      noto: "Noto",
      letojanni: "letojanni",
      comisoairport: "Comiso Aeropuerto",
      messinaport: "Messina puerto",
      milazzo: "Milazzo",
      milazzoport: "Milazzo puerto",
      acireale: "Acireale",
      modica: "Modica",
      augusta: "Augusta",
      sigonella: "Sigonella",
      marzamemi: "Marzamemi",
      goledellalcantara: "Gole dell'Alcantara",
      caltagirone: "Caltagirone",
      trapaniport: "Trapani puerto",
      dattilo: "Dattilo",
      altavillamilicia: "Altavilla Milicia",
      trabia: "Trabia",
      giardinellozucco: "Giardinello Zucco",
      addaura: "Addaura",
      scopello: "Scopello",
      bolognetta: "Bolognetta",
      campofelicediroccella: "Campofelice di Roccella",
      parcodellemadonie: "Parco delle Madonie",
      pianadeglialbanesi: "Piana degli Albanesi",
      altofonte: "Altofonte",
      partinico: "Partinico",
      balestrate: "Balestrate",
      terminiimerese: "Termini Imerese",
      villabate: "Villabate",
      alcamo: "Alcamo",
      casteldaccia: "Casteldaccia",
      aspra: "Aspra",
      misilmeri: "Misilmeri",
      montelepre: "Montelepre",
      macari: "Macari",
      termesegestane: "Terme Segestane",
      sangiuseppejato: "San Giuseppe Jato",
      borgetto: "Borgetto",
      giacalone: "Giacalone",
      ciminna: "Ciminna",
      paceco: "Paceco",
      vicari: "Vicari",
      lercarafriddi: "Lercara Friddi",
      sannicolalarena: "San Nicola l'Arena",
      isoladellefemmine: "Isola delle Femmine",
      capaci: "Capaci",
      carini: "Carini",
      custonaci: "Custonaci",
      gioiosamarea: "Gioiosa Marea",
      licata: "Licata",
      pollina: "Pollina",
      portoempedocle: "Porto Empedocle",
      prizzi: "Prizzi",
      sferracavallo: "Sferracavallo",
      trappeto: "Trappeto",
      valderice: "Valderice",
      acitrezza: "Aci Trezza",
      calatabiano: "Calatabiano",
      giarre: "Giarre",
      messina: "Messina",
      ragusa: "Ragusa",
      portorosa: "Portorosa",
      ortigia: "Ortigia"
    }; 
  }
}

// Updated 27.09.2026
var pricesPalermoAirport = {
  top: [],
  palermocity: [55, 80],
  palermoport: [55, 80],
  mondello: [50, 65],
  monreale: [65, 90],
  cinisi: [35, 50],
  terrasini: [45, 70],
  castellamaredelgolfo: [90, 130],
  sanvitolocapo: [170, 200],
  erice: [150, 180],
  trapani: [150, 180],
  trapanibirgiairport: [150, 200],
  mozia: [150, 180],
  castelvetrano: [170, 210],
  selinunte: [180, 220],
  marsala: [190, 220],
  sambucadisicilia: [180, 230],
  mazaradelvallo: [200, 240],
  bagheria: [95, 135],
  santaflavia: [100, 130],
  cefalu: [170, 200],
  corleone: [140, 180],
  agrigento: [250, 300],
  menfi: [190, 230],
  sciacca: [220, 270],
  portopalo: [200, 240],
  scaladeiturchi: [250, 300],
  enna: [300, 330],
  caltanissetta: [300, 350],
  siciliavillageoutlet: [300, 350],
  piazzaarmerina: [400, 450],
  cataniaairport: [550, 700],
  cataniacity: [550, 700],
  etna: [450, 500],
  taormina: [600, 750],
  giardininaxos: [600, 750],
  calatabiano: [600, 750],
  giarre: [600, 750],
  siracusa: [600, 750],
  ortigia: [600, 750],
  ragusa: [600, 750],
  marinadiragusa: [600, 750],
  noto: [550, 700],
  letojanni: [600, 750],
  comisoairport: [600, 750],
  messina: [550, 700],
  messinaport: [550, 700],
  milazzo: [400, 550],
  milazzoport: [400, 550],
  portorosa: [400, 550],
  acireale: [550, 700],
  acitrezza: [550, 700],
  modica: [550, 700],
  augusta: [550, 700],
  sigonella: [550, 700],
  marzamemi: [600, 750],
  caltagirone: [480, 520],
  balestrate: [65, 100],
  bolognetta: [120, 150],
  partinico: [55, 80],
  terminiimerese: [130, 160],
  casteldaccia: [95, 135],
  trabia: [110, 140],
  campofelicediroccella: [150, 180],
  alcamo: [80, 120],
  capaci: [40, 60],
  isoladellefemmine: [40, 60],
  carini: [35, 50],
  custonaci: [140, 180],
  gioiosamarea: [450, 600],
  licata: [550, 700],
  macari: [150, 200],
  pollina: [200, 250],
  portoempedocle: [280, 330],
  prizzi: [230, 270],
  sferracavallo: [45, 70],
  trappeto: [65, 100],
  valderice: [150, 200],
  pianadeglialbanesi: [100, 140],
  altavillamilicia: [100, 140],
  montelepre: [50, 90],
  scopello: [95, 120]
}

// Updated 27.09.2026
var pricesPalermoCity = {
  top: [],
  palermoairport: [55, 80],
  mondello: [35, 60],
  monreale: [30, 60],
  cinisi: [70, 100],
  terrasini: [70, 110],
  castellamaredelgolfo: [140, 180],
  sanvitolocapo: [200, 240],
  erice: [180, 220],
  trapani: [190, 230],
  trapanibirgiairport: [200, 240],
  mozia: [200, 240],
  castelvetrano: [200, 250],
  selinunte: [200, 250],
  marsala: [250, 300],
  sambucadisicilia: [160, 200],
  mazaradelvallo: [240, 280],
  bagheria: [50, 90],
  santaflavia: [50, 90],
  cefalu: [130, 170],
  corleone: [120, 160],
  agrigento: [250, 300],
  menfi: [200, 240],
  sciacca: [200, 250],
  scaladeiturchi: [250, 300],
  enna: [250, 290],
  caltanissetta: [250, 290],
  siciliavillageoutlet: [250, 290],
  piazzaarmerina: [400, 450],
  cataniaairport: [550, 700],
  cataniacity: [550, 700],
  etna: [490, 550],
  taormina: [600, 750],
  giardininaxos: [600, 750],
  calatabiano: [600, 750],
  giarre: [600, 750],
  siracusa: [600, 750],
  ortigia: [600, 750],
  ragusa: [600, 750],
  marinadiragusa: [600, 750],
  noto: [550, 700],
  letojanni: [600, 750],
  comisoairport: [600, 750],
  messina: [550, 700],
  messinaport: [550, 700],
  milazzo: [400, 550],
  milazzoport: [400, 550],
  portorosa: [400, 550],
  acireale: [550, 700],
  acitrezza: [550, 700],
  modica: [550, 700],
  augusta: [550, 700],
  sigonella: [550, 700],
  marzamemi: [600, 750],
  caltagirone: [470, 520],
  balestrate: [120, 160],
  bolognetta: [60, 100],
  partinico: [70, 110],
  terminiimerese: [90, 130],
  casteldaccia: [55, 100],
  trabia: [70, 100],
  campofelicediroccella: [120, 150],
  alcamo: [130, 170],
  altavillamilicia: [50, 90],
  capaci: [40, 60],
  isoladellefemmine: [40, 60],
  custonaci: [170, 220],
  gioiosamarea: [450, 600],
  licata: [550, 700],
  macari: [180, 220],
  montelepre: [50, 90],
  pollina: [150, 190],
  portoempedocle: [200, 240],
  portopalo: [200, 240],
  prizzi: [180, 230],
  sferracavallo: [40, 60],
  trappeto: [120, 160],
  valderice: [180, 220],
  pianadeglialbanesi: [60, 100]
}

// Updated 27.09.2026
var pricesCapaciIsolaDelleFemmine = {
  top: [],
  palermoairport: [40, 60],
  palermocity: [40, 60],
  palermoport: [40, 60],
  mondello: [25, 40],
  monreale: [50, 75],
  cinisi: [45, 60],
  terrasini: [50, 65],
  castellamaredelgolfo: [110, 130],
  sanvitolocapo: [180, 230],
  riservadellozingaro: [135, 170],
  trapaniport: [160, 220],
  dattilo: [140, 170],
  altavillamilicia: [80, 130],
  trabia: [90, 150],
  giardinellozucco: [60, 90],
  addaura: [30, 50],
  scopello: [100, 130],
  bagheria: [70, 115],
  santaflavia: [90, 150],
  cefalu: [150, 200],
  bolognetta: [80, 130],
  campofelicediroccella: [130, 170],
  parcodellemadonie: [170, 220],
  pianadeglialbanesi: [70, 100],
  altofonte: [60, 95],
  partinico: [60, 90],
  balestrate: [70, 100],
  terminiimerese: [120, 160],
  villabate: [60, 90],
  alcamo: [110, 150],
  casteldaccia: [70, 100],
  aspra: [70, 115],
  misilmeri: [70, 100],
  montelepre: [70, 100],
  macari: [180, 200],
  termesegestane: [100, 135],
  sangiuseppejato: [80, 110],
  borgetto: [65, 105],
  giacalone: [70, 100],
  ciminna: [90, 130],
  paceco: [130, 160],
  vicari: [120, 150],
  lercarafriddi: [130, 160],
  sannicolalarena: [80, 110],
  trapanibirgiairport: [160, 220],
  custonaci: [170, 220],
  gioiosamarea: [450, 600],
  licata: [550, 700],
  pollina: [180, 220],
  portoempedocle: [250, 300],
  portopalo: [200, 240],
  prizzi: [180, 230],
  sferracavallo: [25, 55],
  trappeto: [100, 140],
  valderice: [180, 220],
  cataniaairport: [550, 700],
  cataniacity: [550, 700],
  taormina: [600, 750],
  giardininaxos: [600, 750],
  calatabiano: [600, 750],
  giarre: [600, 750],
  siracusa: [600, 750],
  ortigia: [600, 750],
  ragusa: [600, 750],
  marinadiragusa: [600, 750],
  noto: [550, 700],
  letojanni: [600, 750],
  comisoairport: [600, 750],
  messina: [550, 700],
  messinaport: [550, 700],
  milazzo: [400, 550],
  milazzoport: [400, 550],
  portorosa: [400, 550],
  acireale: [550, 700],
  acitrezza: [550, 700],
  modica: [550, 700],
  augusta: [550, 700],
  sigonella: [550, 700],
  marzamemi: [600, 750]
};




//- Объект с основными точками
// Значения свойств - объект с соответсвующими направлениями из этой точки
//Создаем, чтобы была связь между элементами списка SELECT и соответствующими направлениями с ценами
var mainPoints = { 
  palermoairport: pricesPalermoAirport,
  palermocity: pricesPalermoCity,
  capaci: pricesCapaciIsolaDelleFemmine,
  isoladellefemmine: pricesCapaciIsolaDelleFemmine
};

let airports = ["cataniaairport", "palermoairport", "comisoairport", "trapanibirgiairport"];
let ports = ["palermoport", "messinaport", "trapaniport", "milazzoport"];

var keysMainPoints = Object.keys(mainPoints); //получаем массив ("cataniaairport", "cataniacenter", "taormina" ...)

let typesRoutes = {
  "airport": {"city": "airport-city", "port": "airport-port", "airport": "airport-airport"},
  "port": {"city": "port-city", "airport": "port-airport", "port": "port-port"},
  "city": {"airport": "city-airport", "port": "city-port", "city": "city-city"},
};

